import React from 'react';

const COUNTRY_COLORS = {
  US: '#3b82f6',
  UK: '#ef4444',
  MX: '#10b981',
  IL: '#f59e0b',
  CA: '#8b5cf6',
};

const COUNTRY_LABELS = {
  US: 'USA', UK: 'UK', MX: 'Mexico', IL: 'Israel', CA: 'Canada',
};

export default function CountryChart({ opportunities }) {
  const counts = {};
  (opportunities || []).forEach(o => {
    const c = (o.address_country || 'Unknown').toUpperCase();
    counts[c] = (counts[c] || 0) + 1;
  });

  const total = Object.values(counts).reduce((a, b) => a + b, 0);
  if (total === 0) return null;

  const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);

  return (
    <div className="mini-chart">
      <div className="mini-chart-title">BY COUNTRY</div>
      {entries.map(([country, count]) => (
        <div key={country} className="mini-chart-row">
          <div className="mini-chart-label">{COUNTRY_LABELS[country] || country}</div>
          <div className="mini-chart-bar-wrap">
            <div
              className="mini-chart-bar"
              style={{
                width: `${(count / total) * 100}%`,
                background: COUNTRY_COLORS[country] || '#4a7090',
              }}
            />
          </div>
          <div className="mini-chart-count">{count}</div>
        </div>
      ))}
    </div>
  );
}
